module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00030.7fc7705a.png";